import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=d676dc3a&scoped=true&"
import script from "./Detail.js?vue&type=script&lang=js&"
export * from "./Detail.js?vue&type=script&lang=js&"
import style0 from "./Detail.scss?vue&type=style&index=0&id=d676dc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d676dc3a",
  null
  
)

export default component.exports